import { FC } from "react";

import { Select, Tooltip } from "antd";
import { ForecastMode, ForecastModeT } from "store/features";

type ForecastModeSelectT = {
  onChange: (v: ForecastModeT) => void;
  value: ForecastModeT;
};

const { Option } = Select;

const ForecastModeSelect: FC<ForecastModeSelectT> = ({ onChange, value }) => {
  return (
    <Select style={{ width: "auto" }} value={value} onChange={onChange}>
      <Option value={ForecastMode.Trump}>
        <Tooltip placement="right" title="Project forecasts trump EVA Research forecasts">
          Forecast Trumping
        </Tooltip>
      </Option>
      <Option value={ForecastMode.Compare}>
        <Tooltip
          placement="right"
          title="Compare any two forecast folders. Project forecasts are shown from end of historical production.">
          Forecast Compare
        </Tooltip>
      </Option>
    </Select>
  );
};

export default ForecastModeSelect;
